"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: billing/bill-service.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fbilling%2Fbill-service.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.BillServiceClient = exports.GetAvailableAutoPayDaysResponse = exports.GetAvailableAutoPayDaysRequest = exports.GetBilledAccountResponse = exports.GetBilledAccountRequest = exports.GetCurrentStatementResponse = exports.GetCurrentStatementRequest = exports.GetLastStatementInterestResponsePaidInterest = exports.GetLastStatementInterestResponse = exports.GetLastStatementInterestRequest = exports.DeprecatedOutstandingBill = exports.GetOutstandingBillsResponse = exports.GetOutstandingBillsRequest = exports.ListStatementsResponse = exports.ListStatementsRequest = void 0;
/* eslint-disable */
const rpc_1 = require("@getstep/proto-lib/rpc");
const amount_1 = require("../common/amount");
const bill_status_1 = require("./bill-status");
const billed_account_1 = require("./billed-account");
const statement_1 = require("./statement");
const protobufPackage = 'com.step.billing.proto';
function createBaseListStatementsRequest() {
    return { primaryAccountId: '' };
}
exports.ListStatementsRequest = {
    fromJSON(object) {
        const message = {
            primaryAccountId: isSet(object.primaryAccountId)
                ? globalThis.String(object.primaryAccountId)
                : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.primaryAccountId !== '') {
            obj.primaryAccountId = message.primaryAccountId;
        }
        return obj;
    },
    create(base) {
        return exports.ListStatementsRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseListStatementsRequest();
        message.primaryAccountId = object.primaryAccountId ?? '';
        return message;
    },
};
function createBaseListStatementsResponse() {
    return { statement: [], statements: [] };
}
exports.ListStatementsResponse = {
    fromJSON(object) {
        const message = {
            statement: globalThis.Array.isArray(object?.statement)
                ? object.statement.map((e) => statement_1.Statement.fromJSON(e))
                : [],
            statements: globalThis.Array.isArray(object?.statements)
                ? object.statements.map((e) => statement_1.StatementV2.fromJSON(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.statement?.length) {
            obj.statement = message.statement.map((e) => statement_1.Statement.toJSON(e));
        }
        if (message.statements?.length) {
            obj.statements = message.statements.map((e) => statement_1.StatementV2.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.ListStatementsResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseListStatementsResponse();
        message.statement = object.statement?.map((e) => statement_1.Statement.fromPartial(e)) || [];
        message.statements = object.statements?.map((e) => statement_1.StatementV2.fromPartial(e)) || [];
        return message;
    },
};
function createBaseGetOutstandingBillsRequest() {
    return {};
}
exports.GetOutstandingBillsRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.GetOutstandingBillsRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseGetOutstandingBillsRequest();
        return message;
    },
};
function createBaseGetOutstandingBillsResponse() {
    return { outstandingBills: [] };
}
exports.GetOutstandingBillsResponse = {
    fromJSON(object) {
        const message = {
            outstandingBills: globalThis.Array.isArray(object?.outstandingBills)
                ? object.outstandingBills.map((e) => exports.DeprecatedOutstandingBill.fromJSON(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.outstandingBills?.length) {
            obj.outstandingBills = message.outstandingBills.map((e) => exports.DeprecatedOutstandingBill.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.GetOutstandingBillsResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetOutstandingBillsResponse();
        message.outstandingBills =
            object.outstandingBills?.map((e) => exports.DeprecatedOutstandingBill.fromPartial(e)) || [];
        return message;
    },
};
function createBaseDeprecatedOutstandingBill() {
    return {
        primaryAccountId: '',
        billingDateMs: '0',
        status: bill_status_1.BillStatus.INVALID_BILL_STATUS,
        outstandingAmount: amount_1.Amount.fromPartial({}),
        dueAtMs: '0',
    };
}
exports.DeprecatedOutstandingBill = {
    fromJSON(object) {
        const message = {
            primaryAccountId: isSet(object.primaryAccountId)
                ? globalThis.String(object.primaryAccountId)
                : '',
            billingDateMs: isSet(object.billingDateMs) ? globalThis.String(object.billingDateMs) : '0',
            status: isSet(object.status)
                ? (0, bill_status_1.billStatusFromJSON)(object.status)
                : bill_status_1.BillStatus.INVALID_BILL_STATUS,
            outstandingAmount: isSet(object.outstandingAmount)
                ? amount_1.Amount.fromJSON(object.outstandingAmount)
                : amount_1.Amount.fromPartial({}),
        };
        if (isSet(object.dueAtMs)) {
            message.dueAtMs = globalThis.String(object.dueAtMs);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.primaryAccountId !== '') {
            obj.primaryAccountId = message.primaryAccountId;
        }
        if (message.billingDateMs !== '0') {
            obj.billingDateMs = message.billingDateMs;
        }
        if (message.status !== bill_status_1.BillStatus.INVALID_BILL_STATUS) {
            obj.status = (0, bill_status_1.billStatusToJSON)(message.status);
        }
        if (message.outstandingAmount !== undefined) {
            obj.outstandingAmount = amount_1.Amount.toJSON(message.outstandingAmount);
        }
        if (message.dueAtMs !== undefined && message.dueAtMs !== '0') {
            obj.dueAtMs = message.dueAtMs;
        }
        return obj;
    },
    create(base) {
        return exports.DeprecatedOutstandingBill.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseDeprecatedOutstandingBill();
        message.primaryAccountId = object.primaryAccountId ?? '';
        message.billingDateMs = object.billingDateMs ?? '0';
        message.status = object.status ?? bill_status_1.BillStatus.INVALID_BILL_STATUS;
        message.outstandingAmount =
            (object.outstandingAmount !== undefined && object.outstandingAmount !== null)
                ? amount_1.Amount.fromPartial(object.outstandingAmount)
                : amount_1.Amount.fromPartial({});
        message.dueAtMs = object.dueAtMs ?? '0';
        return message;
    },
};
function createBaseGetLastStatementInterestRequest() {
    return { primaryAccountId: '' };
}
exports.GetLastStatementInterestRequest = {
    fromJSON(object) {
        const message = {
            primaryAccountId: isSet(object.primaryAccountId)
                ? globalThis.String(object.primaryAccountId)
                : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.primaryAccountId !== '') {
            obj.primaryAccountId = message.primaryAccountId;
        }
        return obj;
    },
    create(base) {
        return exports.GetLastStatementInterestRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetLastStatementInterestRequest();
        message.primaryAccountId = object.primaryAccountId ?? '';
        return message;
    },
};
function createBaseGetLastStatementInterestResponse() {
    return { interest: undefined };
}
exports.GetLastStatementInterestResponse = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.interest)) {
            message.interest = exports.GetLastStatementInterestResponsePaidInterest.fromJSON(object.interest);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.interest !== undefined) {
            obj.interest = exports.GetLastStatementInterestResponsePaidInterest.toJSON(message.interest);
        }
        return obj;
    },
    create(base) {
        return exports.GetLastStatementInterestResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetLastStatementInterestResponse();
        message.interest = (object.interest !== undefined && object.interest !== null)
            ? exports.GetLastStatementInterestResponsePaidInterest.fromPartial(object.interest)
            : undefined;
        return message;
    },
};
function createBaseGetLastStatementInterestResponsePaidInterest() {
    return { totalEarned: amount_1.Amount.fromPartial({}), apyRate: 0 };
}
exports.GetLastStatementInterestResponsePaidInterest = {
    fromJSON(object) {
        const message = {
            totalEarned: isSet(object.totalEarned)
                ? amount_1.Amount.fromJSON(object.totalEarned)
                : amount_1.Amount.fromPartial({}),
            apyRate: isSet(object.apyRate) ? globalThis.Number(object.apyRate) : 0,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.totalEarned !== undefined) {
            obj.totalEarned = amount_1.Amount.toJSON(message.totalEarned);
        }
        if (message.apyRate !== 0) {
            obj.apyRate = message.apyRate;
        }
        return obj;
    },
    create(base) {
        return exports.GetLastStatementInterestResponsePaidInterest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetLastStatementInterestResponsePaidInterest();
        message.totalEarned = (object.totalEarned !== undefined && object.totalEarned !== null)
            ? amount_1.Amount.fromPartial(object.totalEarned)
            : amount_1.Amount.fromPartial({});
        message.apyRate = object.apyRate ?? 0;
        return message;
    },
};
function createBaseGetCurrentStatementRequest() {
    return { primaryAccountId: '' };
}
exports.GetCurrentStatementRequest = {
    fromJSON(object) {
        const message = {
            primaryAccountId: isSet(object.primaryAccountId)
                ? globalThis.String(object.primaryAccountId)
                : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.primaryAccountId !== '') {
            obj.primaryAccountId = message.primaryAccountId;
        }
        return obj;
    },
    create(base) {
        return exports.GetCurrentStatementRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetCurrentStatementRequest();
        message.primaryAccountId = object.primaryAccountId ?? '';
        return message;
    },
};
function createBaseGetCurrentStatementResponse() {
    return { statement: undefined };
}
exports.GetCurrentStatementResponse = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.statement)) {
            message.statement = statement_1.StatementV2.fromJSON(object.statement);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.statement !== undefined) {
            obj.statement = statement_1.StatementV2.toJSON(message.statement);
        }
        return obj;
    },
    create(base) {
        return exports.GetCurrentStatementResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetCurrentStatementResponse();
        message.statement = (object.statement !== undefined && object.statement !== null)
            ? statement_1.StatementV2.fromPartial(object.statement)
            : undefined;
        return message;
    },
};
function createBaseGetBilledAccountRequest() {
    return { primaryAccountId: '' };
}
exports.GetBilledAccountRequest = {
    fromJSON(object) {
        const message = {
            primaryAccountId: isSet(object.primaryAccountId)
                ? globalThis.String(object.primaryAccountId)
                : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.primaryAccountId !== '') {
            obj.primaryAccountId = message.primaryAccountId;
        }
        return obj;
    },
    create(base) {
        return exports.GetBilledAccountRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetBilledAccountRequest();
        message.primaryAccountId = object.primaryAccountId ?? '';
        return message;
    },
};
function createBaseGetBilledAccountResponse() {
    return { account: billed_account_1.BilledAccount.fromPartial({}) };
}
exports.GetBilledAccountResponse = {
    fromJSON(object) {
        const message = {
            account: isSet(object.account)
                ? billed_account_1.BilledAccount.fromJSON(object.account)
                : billed_account_1.BilledAccount.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.account !== undefined) {
            obj.account = billed_account_1.BilledAccount.toJSON(message.account);
        }
        return obj;
    },
    create(base) {
        return exports.GetBilledAccountResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetBilledAccountResponse();
        message.account = (object.account !== undefined && object.account !== null)
            ? billed_account_1.BilledAccount.fromPartial(object.account)
            : billed_account_1.BilledAccount.fromPartial({});
        return message;
    },
};
function createBaseGetAvailableAutoPayDaysRequest() {
    return { primaryAccountId: '' };
}
exports.GetAvailableAutoPayDaysRequest = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.primaryAccountId)) {
            message.primaryAccountId = globalThis.String(object.primaryAccountId);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.primaryAccountId !== undefined && message.primaryAccountId !== '') {
            obj.primaryAccountId = message.primaryAccountId;
        }
        return obj;
    },
    create(base) {
        return exports.GetAvailableAutoPayDaysRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetAvailableAutoPayDaysRequest();
        message.primaryAccountId = object.primaryAccountId ?? '';
        return message;
    },
};
function createBaseGetAvailableAutoPayDaysResponse() {
    return { days: [] };
}
exports.GetAvailableAutoPayDaysResponse = {
    fromJSON(object) {
        const message = {
            days: globalThis.Array.isArray(object?.days)
                ? object.days.map((e) => globalThis.Number(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.days?.length) {
            obj.days = message.days.map((e) => Math.round(e));
        }
        return obj;
    },
    create(base) {
        return exports.GetAvailableAutoPayDaysResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetAvailableAutoPayDaysResponse();
        message.days = object.days?.map((e) => e) || [];
        return message;
    },
};
/**
 * Billing Service API.
 *
 * Public API for billing & bills.
 */
class BillServiceClient {
    rpc;
    name = 'com.step.billing.proto.BillService';
    type = rpc_1.ServiceType.PUBLIC;
    path = '/billing';
    methods = [{
            name: 'ListStatements',
            requestType: exports.ListStatementsRequest,
            responseType: exports.ListStatementsResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'GetOutstandingBills',
            requestType: exports.GetOutstandingBillsRequest,
            responseType: exports.GetOutstandingBillsResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'GetLastStatementInterest',
            requestType: exports.GetLastStatementInterestRequest,
            responseType: exports.GetLastStatementInterestResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'GetCurrentStatement',
            requestType: exports.GetCurrentStatementRequest,
            responseType: exports.GetCurrentStatementResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'GetBilledAccount',
            requestType: exports.GetBilledAccountRequest,
            responseType: exports.GetBilledAccountResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'GetAvailableAutoPayDays',
            requestType: exports.GetAvailableAutoPayDaysRequest,
            responseType: exports.GetAvailableAutoPayDaysResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }];
    constructor(rpc) {
        this.rpc = rpc;
    }
    /**
     * List all the available statements for an account
     */
    listStatements(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[0],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Retrieves the account billing status for a list of accounts.
     *
     * Deprecated. Use GetCurrentStatement instead.
     */
    getOutstandingBills(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[1],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Retrieves the paid interests on the last statement for the given account.
     *
     * Can be deprecated in favor of GetCurrentStatement once data for StatementV2 are
     * persisted and the information needed is made available in SavingsStatementContext.
     */
    getLastStatementInterest(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[2],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Retrieves the most recent statement for the given account.
     */
    getCurrentStatement(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[3],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Retrieves the billing status for the given account.
     */
    getBilledAccount(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[4],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Get available auto pay days for the given account.
     */
    getAvailableAutoPayDays(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[5],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
}
exports.BillServiceClient = BillServiceClient;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=bill-service.js.map